import React from 'react'

import { Col, Spacer } from '@amzn/stencil-react-components/layout'

import { ItemEditorBasicInfo } from 'src/components/ItemEditorBasicInfo'
import { ResponsiveRow } from 'src/components/ResponsiveRow'
import { useItemEntity, useValidationErrorEntity } from 'src/hooks/useEntity'
import { SingleSelectCheckboxItemDTO } from 'src/models/dto/items/SingleSelectCheckboxItemDTO'
import { ItemEditorProps } from 'src/pages/module-builder/item-editors/ItemEditorContainer'
import { ItemEditorTextArea } from 'src/pages/module-builder/item-editors/ItemEditorInputs'
import { ItemEditorValidationErrors } from 'src/pages/module-builder/item-editors/ItemEditorValidationErrors'
import { SingleSelectCheckboxHandler } from 'src/services/EntityServices/ItemUpdateHandlers/SingleSelectCheckboxHandler'

export const SingleSelectCheckboxItemEditor = ({
    itemId,
    locale,
    workflowEntityId,
    showValidationError,
    editDisabled,
}: ItemEditorProps) => {
    const { entity: itemDTO } = useItemEntity<SingleSelectCheckboxItemDTO>({
        entityId: itemId,
        workflowEntityId,
    })

    const { entity: validationErrorEntity } = useValidationErrorEntity(itemId)

    return (
        <>
            <ItemEditorValidationErrors {...{ itemId, showValidationError }} />
            <ItemEditorBasicInfo
                handler={SingleSelectCheckboxHandler}
                itemId={itemId}
                workflowEntityId={workflowEntityId}
                locale={locale}
                editDisabled={editDisabled}
                showValidationError={showValidationError}
            />
            <Spacer height={'S200'} />
            <ResponsiveRow gridGap='S300' alignItems={'flex-start'} flexWrap={'wrap'}>
                <Col flex='1'>
                    <ItemEditorTextArea
                        inputId={'statement'}
                        locale={locale}
                        value={itemDTO.statementI18N[locale] ?? ''}
                        disabled={editDisabled}
                        itemId={itemDTO.id}
                        setValue={(nextValue: string) => {
                            SingleSelectCheckboxHandler.updateStatement(
                                itemDTO.id,
                                locale,
                                nextValue
                            )
                        }}
                        validationErrorMessage={(
                            validationErrorEntity.validationErrors.statementI18N ?? []
                        ).join(', ')}
                        showError={showValidationError}
                        labelText={'Statement'}
                    />
                </Col>
            </ResponsiveRow>
        </>
    )
}
